/* eslint-disable max-classes-per-file */

import { CatalogTagsTranslation } from '../../modelViewer/Data/catalogTagsTranslation';

export const enum ParsedTreeNodeType {
  Root = 'root', // Base of the tree
  Domain = 'domain', // A node used to represent a domain
  DomainGroup = 'domainGroup', // A node used to represent a domain
  Group = 'group', // A node used to represent a group
  Folder = 'folder', // A node used to represent a folder
  Option = 'option', // A node that represents an option
}

export class ModelTreeNodeData {

}

export class ModelTreeNodeDataOption extends ModelTreeNodeData {
  objectRef : string = '';
  thumbnailRef : string = '';

  groupID : number = 0;
}

export class ModelTreeNodeDataFolder extends ModelTreeNodeData {
  thumbnailRef : string | undefined;
}

export class ModelTreeNode {
  id : number = 0;
  name : string = '';
  type : ParsedTreeNodeType = ParsedTreeNodeType.Root;
  data : ModelTreeNodeData | undefined = undefined;
  children : ModelTreeNode[] = [];
  singleOptionParent: boolean = false;

  // Text plain version of the node
  model: string | undefined = '';
  path: string = '';
  sltxPath: string | undefined;
  // Selected options to be stored in the root only
  selected: string [] | undefined = undefined;
  // translation for these node
  tagTranslation: CatalogTagsTranslation | undefined;
  tagTranslationSection: CatalogTagsTranslation | undefined;
}
